// VCIN Brand: Always use VCIN_COLORS from constants.js - never use Tailwind blue classes
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Home, Plus, User, Camera } from 'lucide-react';
import { VCIN_COLORS } from '../styles/constants';

export default function BottomNav({ activeTab = 'home' }) {
  const navigate = useNavigate();
  const location = useLocation();

  const tabs = [
    { id: 'home', label: 'Home', icon: Home, path: '/' },
    { id: 'gate', label: 'Gate Mode', icon: Camera, path: '/gate-mode' },
    { id: 'log', label: 'Log Sighting', icon: Plus, path: '/log-sighting' },
    { id: 'profile', label: 'Profile', icon: User, path: '/profile' }
  ];

  const handleTabClick = (tab) => {
    if (location.pathname !== tab.path) {
      navigate(tab.path);
    }
  };

  return (
    <nav 
      className="fixed bottom-0 left-0 right-0 h-16 bg-white border-t shadow-lg flex items-center justify-around px-4 z-50"
      style={{ borderColor: '#D8DCE4', paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}
      data-testid="bottom-nav"
    >
      {tabs.map((tab) => {
        const isActive = activeTab === tab.id;
        const Icon = tab.icon;
        
        return (
          <button
            key={tab.id}
            onClick={() => handleTabClick(tab)}
            className="flex flex-col items-center justify-center w-16 h-14 rounded-xl transition-colors"
            style={{
              color: isActive ? VCIN_COLORS.primary : '#5A6174',
              backgroundColor: isActive ? `${VCIN_COLORS.primary}14` : 'transparent'
            }}
            data-testid={`nav-${tab.id}`}
          >
            <Icon className="w-6 h-6 mb-0.5" strokeWidth={isActive ? 2.5 : 2} />
            <span className={`text-xs ${isActive ? 'font-semibold' : 'font-medium'}`}>
              {tab.label}
            </span>
          </button>
        );
      })}
    </nav>
  );
}
